<template>
  <div id="transfer-create" class="row">
    <form id="create-transfer-form" class="small-12 medium-5 columns" @submit.prevent="submitForm">
      <label>
        {{ 'Domain'|t }}
        <input type="text" ref="domain" v-model="domain" required="required" autofocus />
      </label>

      <label>
        {{ 'Authentication password'|t }}
        <input type="text" ref="auth" v-model="auth" required="required" />
      </label>

      <label>
        {{ 'Period'|t }}
        <input type="number" v-model="period" min="0" max="10" required="required" />
      </label>
      <p class="help-text">{{ '0 means no domain renewal will take place, but TLD has to support it. Otherwise value of 1 will be used.'|t }}</p>

      <input type="submit" name="submit" :value="'Submit'|t" class="medium expanded success button" />
    </form>
  </div>
</template>

<script>
  import api from '@/api';
  import router from '@/routes';

  export default {
    name: 'CreateForm',
    data() {
      return {
        domain: "",
        period: 1,
        auth: "",
      }
    },
    methods: {
      submitForm() {
        let request = {
          domain: this.domain,
          period: parseInt(this.period),
          auth_secret: this.auth,
        };
        api.createDomainTransfer(
          request,
          data => {
            this.$store.commit('messages/addMessage', {
              type: "status",
              message: "Transfer for domain %s has been created.",
              args: [data.domain]
            }, {root: true});
            router.push({name: 'transfer.collection'});
          }
        );
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/transfer/CreateForm.vue